// El ícono de cada destino, en un solo lugar.
//
// Lo usan los DOS selectores de destino —el modal de "Nuevo lanzamiento" y el
// menú de "Enviar a lanzamiento"— y por eso no vive adentro de ninguno: si en
// una pantalla Tienda Nube tuviera su nube y en la otra un cuadradito genérico,
// el usuario no podría estar seguro de que es el mismo destino.
//
// Las plataformas reusan `PlatformLogoChip`, que ya resuelve el chip blanco con
// el logo de cada marca adentro (ADR-682): sobre el fondo neutro de una opción
// sin elegir y sobre el gris de la elegida, el logo se ve siempre igual.
import { Store } from 'lucide-react';
import { PlatformLogoChip } from '../../components/PlatformLogos';
import type { CanalLanzamiento } from './canales';

/**
 * El mismo tamaño y borde que el chip de las marcas, para que la lista alinee.
 * `border-neutral-200` sin opacidad: con `/80` la clase no genera CSS (ver la
 * nota en `PlatformLogos.tsx`).
 */
function ChipNeutro({ children }: { children: React.ReactNode }) {
  return (
    <span
      className="inline-flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-[8px] border border-neutral-200 bg-white text-neutral-400"
      aria-hidden="true"
    >
      {children}
    </span>
  );
}

/**
 * Los destinos que todavía no son una plataforma concreta llevan un ícono
 * neutro: poner el logo de una marca cualquiera sería prometer esa.
 */
export default function IconoDeCanal({ canal }: { canal: CanalLanzamiento }) {
  if (canal === 'tiendanube' || canal === 'mercadolibre' || canal === 'vtex') return <PlatformLogoChip id={canal} />;
  // Redes dejó de ser "redes en general": es Instagram, con su calendario de
  // posts (ADR-2026-09-15-un-lanzamiento-de-redes-es-un-calendario-de-posts).
  // El ícono genérico de compartir ya no describía a dónde va.
  if (canal === 'redes') return <PlatformLogoChip id="instagram" />;
  return (
    <ChipNeutro>
      <Store className="h-4 w-4" />
    </ChipNeutro>
  );
}
